(function () {
  'use strict';

  var ICON_SELECTOR = '.social-icon-img, .contact-icon';

  function darkVariant(url) {
    if (!url) return url;
    return url
      .replace(/mc(\.[a-z0-9]+)(\?.*)?$/i, 'mn$1$2')
      .replace(/_mc(\.[a-z0-9]+)(\?.*)?$/i, '_mn$1$2')
      .replace(/-mc(\.[a-z0-9]+)(\?.*)?$/i, '-mn$1$2');
  }

  function applyIconTheme() {
    var isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    document.querySelectorAll(ICON_SELECTOR).forEach(function (img) {
      if (!img || !img.src) return;
      if (!img.dataset.lightSrc) img.dataset.lightSrc = img.src;
      var lightSrc = img.dataset.lightSrc;
      var target = isDark ? darkVariant(lightSrc) : lightSrc;
      if (target && img.src !== target) img.src = target;
    });
  }

  function init() {
    applyIconTheme();
    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme';
      });
      if (shouldUpdate) applyIconTheme();
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(function () {
  'use strict';

  var ITALY = {
    tabId: 'pmy-italy-day-trips',
    checkoutDataId: 'tour-data-pmy-italy-amalfi',
    collectionTitle: 'Day Trips',
    collectionUrl: '/collections/day-trips-italy',
    collectionImage: 'https://cdn.shopify.com/s/files/1/0757/2075/3419/collections/8_6f4e0c7e-83c7-40ed-8927-caefcb0e4c51.png?v=1787164385',
    productTitle: 'From Naples: Amalfi Coast Private Tour with Driver',
    location: 'Amalfi Coast',
    adultPrice: '€99.00',
    featuredImage: 'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/8_6f4e0c7e-83c7-40ed-8927-caefcb0e4c51.png?v=1787164142',
    languages: 'English, Italian, Spanish',
    variants: [
      { id: 53313407811851, price: 9900, option1: 'Adult (Ages 24 to 63)', option2: '09:00' },
      { id: 53313407844619, price: 7900, option1: 'Group (6+ people)', option2: '09:00' },
      { id: 53313407877387, price: 49900, option1: 'Private Tour (up to 7 pax)', option2: '09:00' }
    ],
    images: [
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/8_6f4e0c7e-83c7-40ed-8927-caefcb0e4c51.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/10_94073848-1290-4db3-90bb-2f093200e4d5.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/1_32ec12d9-e94f-4a44-a905-85b7531b1cbb.png?v=1787164141',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/14.png?v=1787164141',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/5_f03e02e8-5d4b-4f6d-9bf4-5f76ae28b29d.png?v=1787164141',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/11_40ede4d5-255a-43a5-891d-dba9260fbcbf.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/7_a5f8ad12-6d5a-4211-ac7d-50ba4eab54cb.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/9_64b833b9-a0ec-44b3-9ade-892f7f195e74.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/16.png?v=1787164143',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/15.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/2_c4b4b491-0c3c-4e4b-84a9-505d4921ccc3.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/12_594cc50a-b5c2-4032-9e6f-4687537ee016.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/6_a37cf891-7ea3-431b-8089-390f49139d3c.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/3_37f05b1f-fbd8-4679-b239-9c6d00a3b825.png?v=1787164142',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/13.png?v=1787164141',
      'https://cdn.shopify.com/s/files/1/0757/2075/3419/files/4_74177013-b3ec-453d-bd6f-0f8a75615c4f.png?v=1787164142'
    ]
  };

  var portugal = { tourCards: [], tourPanels: [], cityPills: [], cityPanels: [], checkoutDataId: '' };
  var italyEls = {};

  function isItaly() {
    return document.documentElement.getAttribute('data-pmy-destination') === 'italy';
  }

  function addUtilityStyle() {
    if (document.getElementById('pmy-destination-utility-style')) return;
    var style = document.createElement('style');
    style.id = 'pmy-destination-utility-style';
    style.textContent = '.pmy-destination-hidden{display:none!important;}';
    document.head.appendChild(style);
  }

  function ensureItalyCheckoutData() {
    if (document.getElementById(ITALY.checkoutDataId)) return;
    var data = document.createElement('script');
    data.type = 'application/json';
    data.id = ITALY.checkoutDataId;
    data.textContent = JSON.stringify({
      title: ITALY.productTitle,
      image: ITALY.featuredImage,
      currency_symbol: '€',
      is_massage: false,
      languages: ITALY.languages,
      blocked_days: '',
      blocked_dates: '',
      variants: ITALY.variants
    });
    document.body.appendChild(data);
  }

  function selectCheckout(dataId) {
    if (!dataId || typeof window.triggerCheckout !== 'function') return;
    try { window.triggerCheckout(dataId, false); } catch (e) { console.warn('PMY checkout destination sync:', e); }
  }

  function openItalyCheckout() {
    ensureItalyCheckoutData();
    if (typeof window.triggerCheckout === 'function') window.triggerCheckout(ITALY.checkoutDataId, true);
  }

  function bindItalyProductCard(card) {
    if (!card) return;
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', 'Select ' + ITALY.productTitle);
    card.addEventListener('click', openItalyCheckout);
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openItalyCheckout();
      }
    });
  }

  function productCardHtml() {
    return '<div class="product-card shadow-sm pmy-italy-product-card">' +
      '<img src="' + ITALY.featuredImage + '" width="300" height="300" alt="' + ITALY.productTitle.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async">' +
      '<div class="d-flex flex-column flex-grow-1">' +
        '<h5 class="fw-bold">' + ITALY.productTitle + '</h5>' +
        '<div class="card-price-row"><span class="card-price-label">From</span><span class="card-price-value">' + ITALY.adultPrice + '</span></div>' +
      '</div>' +
    '</div>';
  }

  function buildItalyTours() {
    var tours = document.getElementById('tours');
    if (!tours) return false;
    var cardsRow = tours.querySelector('.modalidade-cards-row.collection-square-grid');
    var panelsRow = tours.querySelector('.modalidade-panels-row');
    if (!cardsRow || !panelsRow) return false;

    portugal.tourCards = Array.prototype.slice.call(cardsRow.children);
    portugal.tourPanels = Array.prototype.slice.call(panelsRow.children);

    var slot = document.createElement('div');
    slot.className = 'modalidade-slot-wrap pmy-italy-home';
    slot.innerHTML = '<button type="button" class="collection-square-trigger" data-mod-tab="' + ITALY.tabId + '">' +
      '<div class="collection-square-img"><img src="' + ITALY.collectionImage + '" alt="' + ITALY.collectionTitle + '" loading="lazy"></div>' +
      '<span class="collection-square-label">' + ITALY.collectionTitle + '</span>' +
    '</button>';
    cardsRow.appendChild(slot);

    var panel = document.createElement('div');
    panel.className = 'modalidade-panel pmy-italy-home';
    panel.setAttribute('data-mod-panel', ITALY.tabId);
    panel.innerHTML = '<div class="accordion-item-custom" id="colecao-day-trips-italy"><div class="accordion-body-custom" style="padding-top:30px;"><div class="products-grid">' + productCardHtml() + '</div></div></div>';
    panelsRow.appendChild(panel);
    bindItalyProductCard(panel.querySelector('.pmy-italy-product-card'));

    var button = slot.querySelector('.collection-square-trigger');
    button.addEventListener('click', function () {
      var wasActive = button.classList.contains('is-active');
      button.classList.remove('is-active');
      panel.classList.remove('is-open');
      if (!wasActive) {
        button.classList.add('is-active');
        panel.classList.add('is-open');
        setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);
      }
      renderItalyGallery();
    });

    italyEls.tourSlot = slot;
    italyEls.tourPanel = panel;
    return true;
  }

  function buildItalyCity() {
    var city = document.getElementById('by-city');
    if (!city) return false;
    var pillsRow = city.querySelector('.city-pill-grid');
    var panelsRow = city.querySelector('.modalidade-panels-row');
    if (!pillsRow || !panelsRow) return false;

    portugal.cityPills = Array.prototype.slice.call(pillsRow.children);
    portugal.cityPanels = Array.prototype.slice.call(panelsRow.children);

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'city-pill-trigger pmy-italy-home';
    pill.setAttribute('data-mod-tab', 'city-amalfi-coast');
    pill.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg><span>' + ITALY.location + '</span>';
    pillsRow.appendChild(pill);

    var panel = document.createElement('div');
    panel.className = 'modalidade-panel pmy-italy-home';
    panel.setAttribute('data-mod-panel', 'city-amalfi-coast');
    panel.innerHTML = '<div class="accordion-item-custom"><div class="accordion-body-custom" style="padding-top:30px;"><div class="products-grid">' + productCardHtml() + '</div></div></div>';
    panelsRow.appendChild(panel);
    bindItalyProductCard(panel.querySelector('.pmy-italy-product-card'));

    pill.addEventListener('click', function () {
      var wasActive = pill.classList.contains('is-active');
      pill.classList.remove('is-active');
      panel.classList.remove('is-open');
      if (!wasActive) {
        pill.classList.add('is-active');
        panel.classList.add('is-open');
        setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 100);
      }
    });

    italyEls.cityPill = pill;
    italyEls.cityPanel = panel;
    return true;
  }

  function getGallery() {
    var slider = document.querySelector('[id^="col-gallery-"]');
    if (!slider) return null;
    return { slider: slider, slides: slider.querySelector('.collection-gallery-slides'), thumbs: slider.querySelector('.collection-gallery-thumbs') };
  }

  function setGallerySlide(slider, index) {
    var slides = slider.querySelectorAll('.collection-gallery-slide');
    var thumbs = slider.querySelectorAll('.collection-gallery-thumb');
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    slider.setAttribute('data-current', String(index));
    var track = slider.querySelector('.collection-gallery-slides');
    if (track) track.style.transform = 'translateX(-' + (index * 100) + '%)';
    Array.prototype.forEach.call(thumbs, function (thumb, i) { thumb.classList.toggle('active', i === index); });
    var active = thumbs[index];
    var box = slider.querySelector('.collection-gallery-thumbs');
    if (active && box) {
      var horizontal = box.scrollWidth > box.clientWidth && box.scrollHeight <= box.clientHeight;
      if (horizontal) box.scrollTo({ left: Math.max(0, active.offsetLeft - box.clientWidth / 2 + active.offsetWidth / 2), behavior: 'smooth' });
      else box.scrollTo({ top: Math.max(0, active.offsetTop - box.clientHeight / 2 + active.offsetHeight / 2), behavior: 'smooth' });
    }
  }

  function renderItalyGallery() {
    var g = getGallery();
    if (!g || !g.slides || !g.thumbs) return;
    g.slides.innerHTML = '';
    g.thumbs.innerHTML = '';
    g.slider.style.display = '';
    g.slider.setAttribute('data-current', '0');
    g.slides.style.transform = 'translateX(0%)';

    ITALY.images.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'collection-gallery-slide';
      slide.innerHTML = '<span class="collection-gallery-caption">' + ITALY.productTitle + '</span><img src="' + src + '" alt="' + ITALY.productTitle.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async">';
      g.slides.appendChild(slide);

      var thumb = document.createElement('img');
      thumb.className = 'collection-gallery-thumb' + (i === 0 ? ' active' : '');
      thumb.src = src;
      thumb.alt = ITALY.productTitle;
      thumb.loading = 'lazy';
      thumb.decoding = 'async';
      thumb.addEventListener('click', function () { setGallerySlide(g.slider, i); });
      g.thumbs.appendChild(thumb);
    });

    var prev = g.slider.querySelector('.collection-gallery-prev');
    var next = g.slider.querySelector('.collection-gallery-next');
    if (prev) prev.style.display = '';
    if (next) next.style.display = '';
    g.thumbs.style.display = '';
  }

  function toggleList(list, hide) {
    list.forEach(function (el) {
      el.classList.toggle('pmy-destination-hidden', hide);
      if (hide) {
        el.classList.remove('is-open');
        var active = el.querySelector ? el.querySelector('.is-active') : null;
        if (active) active.classList.remove('is-active');
      }
    });
  }

  function toggleItalyElements(show) {
    Object.keys(italyEls).forEach(function (key) {
      var el = italyEls[key];
      if (el) el.classList.toggle('pmy-destination-hidden', !show);
    });
    if (!show) {
      if (italyEls.tourPanel) italyEls.tourPanel.classList.remove('is-open');
      if (italyEls.tourSlot) {
        var b = italyEls.tourSlot.querySelector('.collection-square-trigger');
        if (b) b.classList.remove('is-active');
      }
      if (italyEls.cityPanel) italyEls.cityPanel.classList.remove('is-open');
      if (italyEls.cityPill) italyEls.cityPill.classList.remove('is-active');
    }
  }

  function toggleGuides(italy) {
    var guides = document.getElementById('guias');
    if (guides) guides.classList.toggle('pmy-destination-hidden', italy);
  }

  function syncCheckout(italy) {
    var checkout = document.getElementById('master-checkout-drawer');
    if (checkout) checkout.style.display = '';
    ensureItalyCheckoutData();
    if (italy) selectCheckout(ITALY.checkoutDataId);
    else if (portugal.checkoutDataId) selectCheckout(portugal.checkoutDataId);
  }

  function applyDestination(destination) {
    var italy = destination === 'italy';
    toggleList(portugal.tourCards, italy);
    toggleList(portugal.tourPanels, italy);
    toggleList(portugal.cityPills, italy);
    toggleList(portugal.cityPanels, italy);
    toggleItalyElements(italy);
    toggleGuides(italy);
    syncCheckout(italy);

    if (italy) renderItalyGallery();
    else if (typeof window.showCollectionGallery === 'function') {
      try { window.showCollectionGallery('all'); } catch (e) {}
    }
  }

  function initDestinationHome() {
    if (!document.getElementById('tours')) return;
    addUtilityStyle();
    var dropdown = document.getElementById('tour-dropdown');
    if (dropdown) portugal.checkoutDataId = dropdown.value || '';
    ensureItalyCheckoutData();
    if (!buildItalyTours()) return;
    buildItalyCity();
    applyDestination(isItaly() ? 'italy' : 'portugal');

    window.addEventListener('pmy:destination-change', function (event) {
      var destination = event && event.detail && event.detail.destination === 'italy' ? 'italy' : 'portugal';
      applyDestination(destination);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDestinationHome, { once: true });
  else initDestinationHome();
})();

(function () {
  'use strict';

  function refreshChipBars() {
    var bars = document.querySelectorAll('.chips-wrapper');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var shouldBeScrolled = window.scrollY > 10;

      /* Rebuild the composited glass layer after a theme change. */
      bar.classList.remove('chips-scrolled');
      void bar.offsetHeight;

      if (shouldBeScrolled) bar.classList.add('chips-scrolled');
    });
  }

  function initChipThemeSync() {
    refreshChipBars();

    var observer = new MutationObserver(function (mutations) {
      var themeChanged = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme';
      });
      if (!themeChanged) return;

      refreshChipBars();
      window.requestAnimationFrame(refreshChipBars);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChipThemeSync, { once: true });
  } else {
    initChipThemeSync();
  }
})();

/* Italy-only isolation: prevents the Portugal gallery/tab controller from
   competing with the destination-specific Italy UI. */
(function () {
  'use strict';

  function isItalyDestination() {
    return document.documentElement.getAttribute('data-pmy-destination') === 'italy';
  }

  function requestItalyRefresh() {
    window.dispatchEvent(new CustomEvent('pmy:destination-change', {
      detail: { destination: 'italy' }
    }));
  }

  function installGalleryGuard() {
    var original = window.showCollectionGallery;
    if (typeof original !== 'function' || original.__pmyItalyGuarded) return;

    function destinationAwareGallery(key) {
      if (isItalyDestination()) {
        requestItalyRefresh();
        return;
      }
      return original.apply(this, arguments);
    }

    destinationAwareGallery.__pmyItalyGuarded = true;
    destinationAwareGallery.__pmyOriginal = original;
    window.showCollectionGallery = destinationAwareGallery;
  }

  function toggleItalyPanel(button, panel) {
    if (!button || !panel) return;
    var stack = button.closest('.modalidade-stack');
    var wasActive = button.classList.contains('is-active');

    if (stack) {
      stack.querySelectorAll('.modalidade-panel').forEach(function (item) {
        item.classList.remove('is-open');
      });
      stack.querySelectorAll('[data-mod-tab]').forEach(function (item) {
        item.classList.remove('is-active');
      });
    } else {
      button.classList.remove('is-active');
      panel.classList.remove('is-open');
    }

    requestItalyRefresh();

    if (!wasActive) {
      button.classList.add('is-active');
      panel.classList.add('is-open');
      window.setTimeout(function () {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }

  function captureItalyTabs(event) {
    if (!isItalyDestination()) return;

    var button = event.target.closest('[data-mod-tab="pmy-italy-day-trips"], [data-mod-tab="city-amalfi-coast"]');
    if (!button) return;

    var target = button.getAttribute('data-mod-tab');
    var stack = button.closest('.modalidade-stack');
    var panel = stack ? stack.querySelector('.modalidade-panel[data-mod-panel="' + target + '"]') : null;
    if (!panel) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggleItalyPanel(button, panel);
  }

  function initItalyIsolation() {
    installGalleryGuard();
    document.addEventListener('click', captureItalyTabs, true);

    window.addEventListener('pmy:destination-change', function () {
      window.requestAnimationFrame(installGalleryGuard);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initItalyIsolation, { once: true });
  } else {
    initItalyIsolation();
  }
})();
